import styled from "styled-components"
import { Link } from "gatsby"

export const Nav = styled.nav`
  margin: 0;
  padding: 0;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 4rem;
  display: flex;
  align-items: center;
  z-index: 200;
  background-color: ${({ theme }) => theme.body};
  box-shadow: 0 2px 1rem 10px rgba(0, 0, 0, 0.2);
  border-bottom: 0.1px solid ${({ theme }) => theme.navBorder};
`
export const HomeLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.fontColor};
  cursor: pointer;
`
export const Content = styled.section`
  width: 100vw;
  max-width: 1170px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`
export const Logo = styled.section`
  font-size: 1.1rem;
  letter-spacing: 1px;
  text-transform: capitalize;
  font-family: var(--ff-secondary);
  font-weight: 800;
  padding: 3px 7px;
  border-radius: 0 0 12px 0;
  border: 2.4px solid ${({ theme }) => theme.fontColor};
  transition: all 0.3s ease-in-out;
  & span {
    color: #3aaeba;
  }

  &:hover {
    border-color: #3aaeba;
  }

  @media (max-width: 350px) {
    font-size: 0.9rem;
    font-weight: 600;
    padding: 2px 4px;
  }
`

export const ThemeTogglerWrapper = styled.section`
  position: absolute;
  top: 50%;
  right: -0.5rem;
  width: 44px;
  height: 20px;
  transform: translate(-50%, -50%);
  background-color: ${({ isDarkTheme }) =>
    !isDarkTheme ? "#5559cc" : "#7babe6"};
  border-radius: 9999px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-around;

  @media (max-width: 768px) {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 44px;
  }
  @media (max-width: 500px) {
    left: 60%;
  }
  & svg {
    color: #ffeb3c;
    fill: #ffeb3c;
  }
`

export const Button = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #ffff;
  border: 2px solid #3aaeba;
  outline: none;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  &.on {
    right: 50%;
    transition: all 0.5s linear;
  }
  &.off {
    right: 0;
    transition: all 0.5s ease-in-out;
  }
`

export const ToggleButton = styled.button`
  font-size: 1.6rem;
  margin-right: 1rem;
  background: transparent;
  border-color: transparent;
  color: var(--clr-primary-5);
  cursor: pointer;
  transition: var(--transition);
  &:hover {
    color: var(--clr-primary-2);
  }

  @media screen and (min-width: 769px) {
    display: none;
  }
`
